import React, { useState } from 'react';
import { connect } from 'react-redux';
import Select from 'react-select';
import capitalize from 'react-bootstrap/lib/utils/capitalize';
import { TableHeaderColumn } from 'react-bootstrap-table';
import { Col, Row } from 'react-bootstrap';
import { Box, DataTable } from '../../../../common/components';

import { applyFilter } from '../../../../common/components/DataTable/redux/dataTableActions';

import formatDateTime from '../../../../helpers/formatDateTime';
import MessageBodyModal from '../../../policy/components/MessageBodyModal/MessageBodyModal';
import EmailAuditModal from '../../../policy/components/EmailAuditModal/EmailAuditModal';

const BrokerApplicationEmails = ({ brokerApplicationId, applyFilter }) => {
  const [statusFilter, setStatusFilter] = useState('');
  const viewMessage = (cell) => {
    return <MessageBodyModal url={cell} />;
  };

  const viewAudit = (cell, row) => {
    return <EmailAuditModal resourceId={cell} resource={row} />;
  };

  const handleStatusFilterChange = (option) => {
    setStatusFilter(option);
    const filter = !option || option.value === 'all' ? '' : option.value;
    applyFilter('emails', 'filter[delivery_status]', filter);
  };

  const formatSender = (sender) => (sender ? sender : 'System Generated');

  return (
    <>
      <Box>
        {/*<h2 className="resource-name">{reference}</h2>*/}
        <Row>
          <Col sm={3} lgOffset={9}>
            <Select
              value={statusFilter}
              clearable
              options={[
                { label: 'All', value: 'all' },
                { label: 'Pending', value: 'pending' },
                { label: 'Processed', value: 'processed' },
                { label: 'Delivered', value: 'delivered' },
                { label: 'Bounce', value: 'bounce' },
                { label: 'Dropped', value: 'dropped' },
                { label: 'Deferred', value: 'deferred' },
              ]}
              onChange={handleStatusFilterChange}
            />
          </Col>
        </Row>
        <div className="hr transparent" />
        <DataTable
          source={'communication/emails'}
          name={'emails'}
          showTotal={false}
          autoFilters={[
            { type: 'filter[broker_application]', value: brokerApplicationId },
          ]}
        >
          <TableHeaderColumn dataField={'id'} isKey={true} hidden={true}>
            Id
          </TableHeaderColumn>
          <TableHeaderColumn dataField="subject" width={'35%'}>
            Subject
          </TableHeaderColumn>
          <TableHeaderColumn dataField="body_url" dataFormat={viewMessage} width={'8%'} />
          <TableHeaderColumn dataField="user" width={'15%'} dataFormat={formatSender}>
            Sender
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="delivery_status"
            dataFormat={capitalize}
            width={'10%'}
          >
            Status
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="delivered_at"
            dataFormat={formatDateTime}
            width={'12%'}
          >
            Processed
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="updated_at"
            dataFormat={formatDateTime}
            width={'12%'}
          >
            Last Activity
          </TableHeaderColumn>
          <TableHeaderColumn dataField="id" dataFormat={viewAudit} width={'8%'} />
        </DataTable>
      </Box>
    </>
  );
};

export default connect(
  null,
  {
    applyFilter: applyFilter,
  },
)(BrokerApplicationEmails);
